import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  name: string;
  children: ReactNode;
}

/** Contains a crashing widget so the rest of the display keeps running. */
export class WidgetBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(`[widget:${this.props.name}]`, error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return <div className="glass muted p-4 text-sm">{this.props.name} is unavailable right now.</div>;
    }
    return this.props.children;
  }
}
